<template>
  <div>
    <div  
      :style="loading.visible ? 
        'z-index: 2000; display: none; position: absolute; left: 0; top: 0;height: 100vh;width:100vw; font-family: \'Arial\', sans-serif;background: linear-gradient(135deg, #4A90E2, #50E3C2);color: #333;justify-content: center;align-items: center;overflow: hidden;' :
        'z-index: 2000; display: flex; position: absolute; left: 0; top: 0;height: 100vh;width:100vw; font-family: \'Arial\', sans-serif;background: linear-gradient(135deg, #4A90E2, #50E3C2);color: #333;justify-content: center;align-items: center;overflow: hidden;'">
      <div 
        style="text-align: center;
        background: #fff;
        border-radius: 15px;
        padding: 40px 30px;
        box-shadow: 0 8px 15px rgba(0, 0, 0, 0.3);
        width: 70%;
        max-width: 400px;">
        <el-image
          src="https://netollie-image-scene-recognition.oss-cn-shanghai.aliyuncs.com/favicon_256.png" 
          style="width: 100px;height: 100px;margin: 0 auto 20px auto;border-radius: 15px;"
          @load="() => {
            loading.close();
            $nextTick(() => {
              $refs.password.focus();
            });}"/>
        <h1 style="font-size: 24px;margin-bottom: 15px;text-transform: uppercase;letter-spacing: 2px;">
          登录
        </h1>
        <input 
          ref="password" type="password" name="password" placeholder="请输入您的密码以继续" autocomplete="off" required
          style="width: 100%;padding: 12px;margin-bottom: 20px;font-size: 16px;border: 1px solid #ccc;border-radius: 25px;box-sizing: border-box;outline: none;transition: all 0.3s ease;"
          onfocus="this.style.borderColor='#1e88e5'; this.style.boxShadow='0 0 8px rgba(30, 136, 229, 0.5)';"
          onblur="this.style.borderColor='#ccc'; this.style.boxShadow='none';"
          v-model="password"
          @input="onPasssowrdInput">
      </div>
    </div>
  </div>
</template>
  
<script>
  export default {
    name: 'IdentityAuthenticate',
    data: () => {
      return {
        password: '',
        loading: null
      }
    },
    props: {
      onAuthenticated: Function
    },
    created() {
      this.loading = this.$loading({ lock: true, spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' });
    },
    methods: {
      async onPasssowrdInput() {
        let onAuthenticated = this.onAuthenticated;
        const encoder = new TextEncoder();
        const data = encoder.encode(this.password);
        const hashBuffer = await crypto.subtle.digest('SHA-256', data);
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
          hashHex === '25aedeebac1cbf16f9478694070a50177f98fc5a7a35f290e6a01341665a0da1'
          && onAuthenticated 
          && onAuthenticated();
        }
    }
  }
  </script>
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
</style>
